<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "views-administrator-backoffice-bonus-bonusAndPromotions",
  mounted() {
    if (this.$route.name == "BonusAndPromotions") {
      this.$router
        .push({
          name: "ListPromotionOnline",
        })
        .catch(() => {});
    }
  },
  watch: {
    $route(val) {
      if (val.name == "BonusAndPromotions") {
        this.$router
          .push({
            name: "ListPromotionOnline",
          })
          .catch(() => {});
      }
    },
  },
};
</script>
